import { render, staticRenderFns } from "./AdminDataDatasources.vue?vue&type=template&id=285c1110&"
import script from "./AdminDataDatasources.vue?vue&type=script&lang=js&"
export * from "./AdminDataDatasources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports